import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable, map } from 'rxjs';
import { CuttingCustomGrooveSchema } from '../../models/cutting/cutting-custom-groove-schema.model';
import { CuttingCustomHoleSchema } from '../../models/cutting/cutting-custom-hole-schema.model';
import { CuttingFastenersSet } from '../../models/cutting/cutting-fasteners-set.model';
import { CuttingPanelBaseSlot, GrooveTypeEnum } from '../../models/cutting/cutting-panel-base-slot.model';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

export interface CustomSlotsOption {
  inPlate: boolean;
  inSide: boolean;
  rabbet: boolean;
  chamfer: boolean;
  fillet: boolean;
  chamfer2: boolean;
}

@Injectable()
export class CountertopSettingsDataService {
  constructor(private http: HttpClient) {}

  public getAvailableHoleSchema(): Observable<CuttingCustomHoleSchema[]> {
    return this.http
      .get<CuttingCustomHoleSchema[]>(ApiLinks.orderCountertop + '/available-custom-holes')
      .pipe(map(res => res.map(s => _.merge(new CuttingCustomHoleSchema(), s))));
  }

  public getAvailableFastenersSetSchema(): Observable<CuttingFastenersSet[]> {
    return this.http
      .get<CuttingFastenersSet[]>(ApiLinks.orderCountertop + '/available-fasteners-sets')
      .pipe(map(res => res.map(s => _.merge(new CuttingFastenersSet(), s))));
  }

  public getAvailableSlots(): Observable<CuttingPanelBaseSlot[]> {
    return this.http.get<CuttingPanelBaseSlot[]>(ApiLinks.orderCountertop + '/available-slots');
  }

  public getCustomSlotOption(): Promise<CustomSlotsOption> {
    return new Promise((resolve, reject) => {
      this.http.get(ApiLinks.customGrooveOptions).subscribe((response: CustomSlotsOption) => {
        resolve(response);
      }, reject);
    });
  }

  public getCustomSlotSchemas(grooveType: GrooveTypeEnum | null): Observable<CuttingCustomGrooveSchema[]> {
    const httpParams = new HttpParams();

    if (!_.isNil(grooveType)) {
      httpParams.append('grooveType', grooveType.toString());
    }

    return this.http.get<CuttingCustomGrooveSchema[]>(ApiLinks.customGrooveSchemas, {
      params: httpParams,
    });
  }

  public addCustomSlot(groove: CuttingPanelBaseSlot, schemaId: number): Observable<number> {
    const httpParams = new HttpParams().set('schemaId', schemaId.toString());

    return this.http.post<number>(ApiLinks.grooves, groove, { params: httpParams });
  }

  public deleteCustomSlot(grooveId: number): Observable<void> {
    return this.http.delete<void>(ApiLinks.grooves + '/' + grooveId);
  }
}
